import React  from 'react';
import MoonStarsSvg from '../../../shared/UI/moonStarsSvg';
import { pluralHelper } from '../../../../helpers/stringutils';
import { connect } from 'react-redux';
import { itineraryListData } from '../../../../helpers/itineraryHelper';
import { get } from '../../../../helpers/objectHelper';


const AccommodationTextPanel = (props) => {

    const { _itinerary, currentStop, hotelMeta } = props;
   
    const { 
        isProduct:_isProduct,
        nights: _nights,
        hasNights:_hasNights,
        reservation,
        productAccommodation,
        cityOrProductName
    } = itineraryListData(currentStop, _itinerary); 

    const address = get([0, 'address'], reservation, '');    

    return (
        <div className="clearfix margin-b-30 accommodation-text-panel">
            <div className="col col-1"><MoonStarsSvg /></div>
            <div className="col col-11">
                <p className={`mb1 ${_hasNights && (reservation || _isProduct ) ? 'medium green-text' : 'bold black-text'}`}>{ _hasNights && (reservation || _isProduct) ? "Accommodation included" : "No Accommodation included"}</p>
                { (!_isProduct && reservation === "") && <p className="radical-text mt1 bold">You have no accommodation selected for your stay in {cityOrProductName}.</p>}

                { 
                  _hasNights && (reservation !== "" && !_isProduct) && 
                  <>  
                    <p className="bold"> {reservation[0].name} </p>
                    <p>{_nights} {pluralHelper('night', _nights)} in {reservation[0].roomType}</p>
                    { reservation[0].type === "hotel" && <p className="f-size-14 agent-portal-grey medium">Board type: {reservation[0].roomBoard}</p> }
                  </>  
                }


                { _hasNights && (reservation === "" && _isProduct) && <p className="bold">{_nights} {pluralHelper('night', _nights)} in {productAccommodation}</p> }

                { (reservation !== "" && reservation[0].isBackstop) && <p className="mt2 info-text p2 rounded"><small>Due to availability we can’t guarantee a booking at the recommended accommodation. We will aim to provide nearby accommodation within 10 min walking distance to the coach (bus) meeting point. </small></p>}
                
                { (reservation !== "" && reservation[0].type === "hotel" && Object.keys(hotelMeta).length > 0) && (
                    <p className="mt2 info-text p2 rounded">
                        <small>{hotelMeta.distance}km ({hotelMeta.duration} minutes walk) from coach meeting point</small> <br/>
                        <small>Hotel address: {address}</small>
                    </p>
                )}

            </div>
        </div>
    )


}



const mapStateToProps = state => {
    return{
      _itinerary:state.currentBooking.filteredItinerary,
      hotelMeta:state.hotel.meta
    }
}

export default connect(mapStateToProps, null)(AccommodationTextPanel); 